import * as routes from "utils/contants/urls";

import {
  ActionItem,
  Actions,
  Label,
  LabelAction,
  LabelHeader,
  Table,
  TableBody,
  TableColumn,
  TableHead,
  TableRow

} from "components/shared/CustomComponentsStyle";
import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import { Col, Row } from "react-bootstrap";

import Pagination from "components/Pagination";

import {
  order,
  statusFinishedFill,
  statusOkFill,
  view
} from "assets/icons/icons";
import { StatusEtapaContratos } from "utils/contants/enums";
import { Creators as formInputsActions } from "store/ducks/formInputs";
import { Body } from "./ListContractsCandidatesStyle";
import BreadCrumb from "components/Layout/breadcrumb";

import { MultSelectCreatable, MultSelect, SelectFieldInput, CheckBox, ButtonSecondary, DatePicker, TextField } from "components/shared/CustomInputs";
import { Filter, Collapse, SelectInput, DataLabel } from "components/shared/CustomComponents";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import Load from "components/Layout/Load";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Creators as messageAction } from "store/ducks/messages";


import { Creators as contractsAction } from "store/ducks/contracts";


const RowColorStage = (status) => {

  let color;


  switch (status) {
    case "Em Analise":
      color = "#f44336";
      break;

    case "Aprovado":
      color = "rgb(95 227 100)";
      break;

    case "Dispensado":
      color = "#86868666";
      break;

    case "Aguardando assinatura":
      color = "#ffeb3b";
      break;

    case "Pendente de liberação":
      color = "orange";
      break;

    case "Contrato assinado":
      color = "rgb(64 171 255)";
      break;

    case "Divergência":
      color = "#ff8868";
      break;

    case "Desistência":
      color = "#86868666";
      break;

    default:
      color = "#ffffff";
      break;
  }


  return ({
    height: '18px',
    width: '18px',
    borderRadius: '50%',
    float: 'left',
    display: 'inline-block', backgroundColor: color
  });


}
const redirect = (url) => {
  window.location.href = url;
}

const ListContractsCandidates = ({
  candidateVacancysContracts,
  candidates,
  isLoading,
  pagination,
  location,
  messagePublication,
  requestInputValues,
  placesOfWork,
  hasMore,

}) => {

  const [agruparPorVaga, setAgruparPorVaga] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);
  const [formValues, setFormValues] = useState({ cpfs: [], idVagas: [], idLocations: [], idStatus: [], dateInitActivity: null });
  const [erroMessage, setErroMessage] = useState({ message: "" });
  const AplicaFiltro = (form, firstPage) => {
    localStorage.setItem("filter_ListContractsCandidates", JSON.stringify(form));
    candidateVacancysContracts({
      nomeFuncionario: form.nomeFuncionario,
      cpfList: form.cpfs,
      idVagasList: form.idVagas,
      idLocaisList: form.idLocations,
      idStatusList: form.idStatus,
      dataAdmissaoPrevista: form.dataAdmissao,
      dateInitActivity: form.dateInitActivity,
      firstPage
    });
    setFormValues(form);
  };
  const loadMore = () => {
    setClearFilter(false);

    AplicaFiltro(formValues, false);
  };

  useEffect(() => {
    requestInputValues(["placeOfWork"]);
    let filter_storaged = JSON.parse(localStorage.getItem("filter_ListContractsCandidates"));

    if (filter_storaged != null) {
      setFormValues(filter_storaged);
      candidateVacancysContracts({
        cpfList: filter_storaged.cpfs, idVagasList: filter_storaged.idVagas,
        idLocaisList: filter_storaged.idLocations, idStatusList: filter_storaged.idStatus, dateInitActivity: filter_storaged.dateInitActivity,
        firstPage: true, recoveredFilter: true, quantidadeItens: filter_storaged.quantidadeItens
      });

    } else {
      candidateVacancysContracts({
        nomeFuncionario: null,
        cpfList: [],
        idVagasList: [],
        idLocaisList: [],
        idStatusList: [],
        dataAdmissaoPrevista: null,
        dateInitActivity: null,
        firstPage: true });
    }
  }, []);

  useEffect(() => {
    let filter_storaged = JSON.parse(localStorage.getItem("filter_ListContractsCandidates"));
    if (filter_storaged != null && !clearFilter) {
      filter_storaged.quantidadeItens = candidates.candidatos? candidates.candidatos.length :20;
      localStorage.setItem("filter_ListContractsCandidates", JSON.stringify(filter_storaged));
      setFormValues(filter_storaged);

    } else {
      setFormValues({ cpfs: [], idVagasList: [], idVagas: [], idLocations: [], idStatus: [], dateInitActivity: null });
    }
  }, [candidates]);

  const Filtrar = () => {
    setClearFilter(false);
    AplicaFiltro(formValues, true);
  }
  const getLocationValues = () => {

    if (formValues.idLocations) {
      return placesOfWork.filter(function (item) {
        return formValues.idLocations.indexOf(item.id) !== -1;
      }).map(e => ({
        label: e.nome,
        value: e.id
      }));
    }

    return [];
  }
  const getStatusEtapaValues = () => {

    if (formValues.idStatus) {
      return StatusEtapaContratos.filter(function (item) {
        return formValues.idStatus.indexOf(item.value) !== -1;
      });
    }

    return [];
  }

  const LimparFiltro = () => {
    setClearFilter(true);
    localStorage.removeItem("filter_ListContractsCandidates");
    setFormValues({});
    AplicaFiltro({}, true);
  }

  const TrataMultiInsert = Insert => {
    setErroMessage({ message: "" });
    let messages = [];
    let result = [];
    Insert.map(item => {
      let conc = item.value.trim().split(/[\s,]+/);
      conc.map(filtItem => {
        let concFiltered = filtItem.replace(/\D/g, ''); 
        if (concFiltered.length === 11) {
          result.push(concFiltered);
        } else {
          messages.push({ message: `CPF ${filtItem} precisa ter 11 dígitos. Não será considerado no filtro.`, type: "warning" });

        }
      });
    });
    messagePublication(messages);
    return result;
  };

  const requestPage = (filter) => { 
    candidateVacancysContracts({ NumeroPagina: filter.NumeroPagina});
  };

  const renderTableItems = (candidates) =>
    candidates.map(candidate => (
      <Link onClick={() => redirect(`${routes.CONTRACT_CANDIDATE}/${candidate.idCandidatoNaEtapa}`)}>
        <TableRow>
          <TableColumn>
            <span class="dot" style={RowColorStage(candidate.statusCandidatoNaEtapa)}></span>
            <Label>{candidate.cpf}</Label>
          </TableColumn>
          <TableColumn ta="left">
            <Label>{candidate.nome}</Label>
          </TableColumn>
          <TableColumn ta="left">
            <Label>{candidate.statusCandidatoNaEtapa}</Label>
          </TableColumn>
          <TableColumn ta="right" action>
            <Actions flexPosition="flex-start">
              <ActionItem>
                {view()}
                <LabelAction>
                  <FormattedMessage id="sharedItems.view" />
                </LabelAction>
              </ActionItem>
            </Actions>
          </TableColumn>
        </TableRow>
      </Link>
    ));
  
  const renderCandidatesTable = (candidatesList) => {
    return (
      <>
      <Table>
        <TableBody>
          <TableRow noBorder>
            <TableHead>
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.cpf" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.nomeCandidato" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.status" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="documentsCandidateList.documents" />
              </LabelHeader>
            </TableHead>
          </TableRow>
          {renderTableItems(candidatesList.candidatos)}
        </TableBody>
      </Table>
      <Pagination getItemsPage={requestPage} pageSize={50} {...pagination} />
      </>
    )
  };
  
  
  const renderCandidatesByGroupTable = candidates =>
    candidates.candidatosPorVaga.map(candidate => (
      <Collapse
        typeStatus={0}
        position={0}
        title={"Vaga " + candidate.idVaga + " - " + candidate.nomeVaga}
      >
        <Table>
  
          <TableBody>
            <TableRow noBorder>
              <TableHead>
                <LabelHeader>
                  <FormattedMessage id="documentsCandidateList.cpf" />
                </LabelHeader>
  
              </TableHead>
              <TableHead ta="left">
                <LabelHeader>
                  <FormattedMessage id="documentsCandidateList.nomeCandidato" />
                </LabelHeader>
  
              </TableHead>
              <TableHead ta="left">
                <LabelHeader>
                  <FormattedMessage id="documentsCandidateList.documentosEnviados" />
                </LabelHeader>
  
              </TableHead>
              <TableHead ta="left">
                <LabelHeader>
                  <FormattedMessage id="documentsCandidateList.status" />
                </LabelHeader>
  
              </TableHead>
              <TableHead ta="left">
                <LabelHeader ta="center">
                  <FormattedMessage id="documentsCandidateList.analisar" />
                </LabelHeader>
  
              </TableHead>
  
            </TableRow>
            {renderTableItems(candidate.candidatesByVacancyList)}
          </TableBody>
        </Table>
      </Collapse>
  
    ));

  if (isLoading) return <Load isLoading={isLoading} />;
  return (
    <React.Fragment>
      <BreadCrumb
        location={location}
        title={<FormattedMessage id="menuTalentBar.selectCandidate" />}
      />
      <Body>
        <Row style={{ marginBottom: "10px" }}>
          <Col style={{display:"flex", justifyContent:"flex-start"}}>
          <Col md={3}>
            <MultSelectCreatable
              style={{boxShadow:"#A5A5A5"}}
              key={5}
              name={<FormattedMessage id="documentsCandidateList.filterCpf" />}
              label={<FormattedMessage id="documentsCandidateList.filterCpf" />}
              isMulti
              options={formValues.cpfs}
              value={
                formValues.cpfs ?
                  formValues.cpfs.map(e => ({
                    label: e,
                    value: e
                  })) : []
              }
              onChange={e =>
                setFormValues({
                  ...formValues,
                  cpfs: e
                    ? TrataMultiInsert(e)
                    : []
                })
              }
            />
          </Col>
          <Col md={3}>
            <MultSelect
              name={<FormattedMessage id="contracts.statusEtapa" />}
              options={StatusEtapaContratos}
              label={<FormattedMessage id="contracts.statusEtapa" />}
              isMulti
              value={getStatusEtapaValues()}
              onChange={e =>
                setFormValues({
                  ...formValues,
                  idStatus: e
                    ? e.map(k => {
                      return k.value;
                    })
                    : []
                })
              }
            />
          </Col>
          <Col md={3}>
            <DatePicker
              style={{ boxShadow:"#A5A5A5",}}
              width="223px"
              value={formValues.dataAdmissao}
              label="Data Admissão Prevista"
              max="2099-12-31"
              min="2023-01-01"
              onChange={(e) => {
                const year = e.target.value.split("-")[0];
                if (year === "" || parseInt(year) > 2099) return;
                setFormValues({
                  ...formValues,
                  dataAdmissao: e.target.value
                });
              }}
            />
          </Col>
          <Col md={3}>
            <TextField
              style={{borderColor:"#A5A5A5"}}
              name={<FormattedMessage id="Nome Funcionário" />}
              label={<FormattedMessage id="Nome Funcionário" />}
              defaultValue={formValues.nomeFuncionario}
              value={formValues.nomeFuncionario}
              placeholder=""
              onChange={(e) =>
                e.target.value
                  ? setFormValues({
                      ...formValues,
                      nomeFuncionario: e.target.value,
                    })
                  : null
              }
            />
          </Col>
          </Col>
        </Row>

        <Row style={{ marginBottom: "10px" }}>
        <Col style={{display:"flex", justifyContent:"flex-start"}}>
          <Col md={4} style={{ marginTop: '15px' }}>
            <ButtonSecondary
              onClick={() => Filtrar()}
              name={(<FormattedMessage id="sharedItems.filter" />)}
            />
          </Col>
          <Col md={4} style={{ marginTop: '15px'}}>
            <ButtonSecondary
              onClick={() => LimparFiltro()}
              name={(<FormattedMessage id="sharedItems.clearFilter" />)}
            />
          </Col>
          <Col md={4} style={{ marginTop: '15px' }}>
            <ButtonSecondary
              onClick={() => redirect(`${routes.CONTRACT_MANAGER}`)}
              name={"Liberar assinaturas"}
            />
          </Col>
          </Col>
        </Row>

        {(candidates.candidatos && !agruparPorVaga && renderCandidatesTable(candidates))}

        {(agruparPorVaga && renderCandidatesByGroupTable(candidates))}
             
        {/* <Pagination getItem={formValues} /> 
           */}
           {/* <ButtonSecondary
            disabled={!hasMore}
            onClick={loadMore}
            isLoading={isLoading}
            name={(<FormattedMessage id="sharedItems.loadMore" />)}

          /> */}
      </Body>

    </React.Fragment>
  );
};
const mapDispatchToProps = dispatch => ({
  candidateVacancysContracts: filter => dispatch(contractsAction.candidatesVacancysContractsRequest(filter)),
  candidateFiles: id => dispatch(contractsAction.candidateFilesRequest(id)),
  setStatusFileRequest: payload => dispatch(contractsAction.candidateSetStatusFileRequest(payload)),
  requestInputValues: inputs => dispatch(formInputsActions.formInputsRequest(inputs)),
  messagePublication: messages => dispatch(messageAction.messagePublication(messages))


});
const mapStateToProps = state => ({
  isLoading: state.contracts.isLoading,
  candidates: state.contracts.candidates,
  placesOfWork: state.formInputs.placeOfWork,
  pagination: state.contracts.pagination,
  hasMore: state.contracts.hasMore,
  quantidadeItens: state.contracts.quantidadeItens,
  pagination: state.contracts.pagination,
});

export default connect(mapStateToProps, mapDispatchToProps)(ListContractsCandidates);

ListContractsCandidates.propTypes = {
  candidates: PropTypes.func,
  page: PropTypes.any,
  hasMore: PropTypes.any,
  quantidadeItens: PropTypes.any,
};

ListContractsCandidates.defaultProps = {
  candidates: () => { }
};
